/**
 * Professions (อาชีพ, professions.ts) in the systems' order: their commands, and their tick (work
 * under way, crops growing, nodes coming back). The rules stay in the `Trades` class, which the
 * World builds and exposes as `world.trades`; this only puts it in its place among the systems.
 */
import type { TradeCommand } from '../professions';
import type { SystemHost, WorldSystem } from './types';

export class TradesSystem implements WorldSystem {
  readonly name = 'trades';

  constructor(private readonly h: SystemHost) {}

  private readonly apply = (c: TradeCommand) => this.h.world.trades.apply(c);

  readonly commands = {
    gather: this.apply,
    plant: this.apply,
    water: this.apply,
    fertilize: this.apply,
    buyTool: this.apply,
    craft: this.apply,
    workStop: this.apply,
    useGood: this.apply,
    buyGood: this.apply,
    sellGood: this.apply,
  };

  step(dt: number): void {
    this.h.world.trades.step(dt);
  }
}
